

import ContactInfo from "../components/Contact/ContactInfo";
import ContactUs from "../components/Contact/ContactUs";
import Slider from "../components/Contact/Slider";


export default function Contact() {

  return (
    <main style={{ backgroundColor: "#ffffff", color: "#1a1a1a", overflowX: "hidden" }}>

      <div >
        <ContactUs/>
        <ContactInfo/>
        <Slider/>
      </div>

    </main>
  );
}